import { globalStyles } from "~/application/theme";

globalStyles();

export const GlobalStyle = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>;
};